import UnassignSerialNumber from "./unassignSerialNumber.container";

export default UnassignSerialNumber;
